/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RequestStatus } from './RequestStatus';
import {
    RequestStatusFromJSON,
    RequestStatusFromJSONTyped,
    RequestStatusToJSON,
} from './RequestStatus';

/**
 * 
 * @export
 * @interface InvestmentRequestUpdatePayload
 */
export interface InvestmentRequestUpdatePayload {
    /**
     * 
     * @type {number}
     * @memberof InvestmentRequestUpdatePayload
     */
    requestId: number;
    /**
     * 
     * @type {RequestStatus}
     * @memberof InvestmentRequestUpdatePayload
     */
    status: RequestStatus;
    /**
     * 
     * @type {string}
     * @memberof InvestmentRequestUpdatePayload
     */
    note?: string;
}



/**
 * Check if a given object implements the InvestmentRequestUpdatePayload interface.
 */
export function instanceOfInvestmentRequestUpdatePayload(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "requestId" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function InvestmentRequestUpdatePayloadFromJSON(json: any): InvestmentRequestUpdatePayload {
    return InvestmentRequestUpdatePayloadFromJSONTyped(json, false);
}

export function InvestmentRequestUpdatePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentRequestUpdatePayload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'requestId': json['request_id'],
        'status': RequestStatusFromJSON(json['status']),
        'note': !exists(json, 'note') ? undefined : json['note'],
    };
}

export function InvestmentRequestUpdatePayloadToJSON(value?: InvestmentRequestUpdatePayload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'request_id': value.requestId,
        'status': RequestStatusToJSON(value.status),
        'note': value.note,
    };
}

